export default __webpack_public_path__ + "static/media/ourpartners.ae49d1b3.svg";